module.exports = function getResource(label, vars = []) {
    let resources = {
        termsOfUseLink: 'les conditions d’utilisation et les',
        privacyPolicyLink: 'Politique de confidentialité',
        privacyPolicyTitle: 'Politique de confidentialité',
        termsOfUseTitle: 'Conditions d’utilisation de Sephora'
    };

    return resources[label];
};
